import type { SubscriptionFlowActiveStep } from '@/features/plans/presentation/constants/subscription-flow-steps';
import { ONBOARDING_PAGE_COPY } from '@/features/authentication/presentation/composables/constants/onboarding.constants';

/** Mesmo CTA do onboarding: encerra sessão e volta ao login. */
export const CHOOSE_PLAN_EXIT_FOOTER_LABEL = ONBOARDING_PAGE_COPY.EXIT_FOOTER_LABEL;
export const CHOOSE_PLAN_EXIT_LOADING_LABEL = ONBOARDING_PAGE_COPY.EXIT_LOADING_LABEL;

/** Título da tela (AuthLayout). */
export const CHOOSE_PLAN_SCREEN_TITLE = 'Escolha seu plano';

/** Passo ativo no stepper do fluxo pós-cadastro (perfil → plano → …). */
export const CHOOSE_PLAN_FLOW_ACTIVE_STEP: SubscriptionFlowActiveStep = 2;

export const CHOOSE_PLAN_SCREEN_LOADING_LIST = 'Carregando planos…';

export const CHOOSE_PLAN_SCREEN_EMPTY =
  'Nenhum plano disponível no momento. Tente novamente mais tarde.';

export const CHOOSE_PLAN_MONTHLY_HINT_PREFIX = 'Cadastre um plano ';
export const CHOOSE_PLAN_MONTHLY_HINT_EMPHASIS = 'mensal ativo';
export const CHOOSE_PLAN_MONTHLY_HINT_SUFFIX =
  ' no admin para exibir a economia em relação à mensalidade nos períodos longos.';

export const CHOOSE_PLAN_SUBSCRIBE_CTA = 'Assinar';
export const CHOOSE_PLAN_CHECKOUT_LOADING_LABEL = 'Abrindo checkout';

/** Duração mínima do loading local após falha (não aplica em sucesso — checkout abre na hora). */
export const CHOOSE_PLAN_CHECKOUT_LOADING_MIN_MS = 2000;

export const CHOOSE_PLAN_FOOTER_STRIPE =
  'Na próxima etapa o pagamento é processado com segurança pelo Stripe.';

export const CHOOSE_PLAN_FOOTER_CONFIRM =
  'Ao concluir o pagamento, seu plano será vinculado à conta assim que o servidor confirmar a transação.';

export const CHOOSE_PLAN_EQUIVALENT_PREFIX = 'Equivale a';
export const CHOOSE_PLAN_EQUIVALENT_SUFFIX = '/mês no período';

export const CHOOSE_PLAN_SAVINGS_PREFIX = 'Economia de';

export const CHOOSE_PLAN_TOAST_PLANS_LOAD_FAILED =
  'Não foi possível carregar os planos. Tente novamente.';

export const CHOOSE_PLAN_TOAST_CHECKOUT_FAILED =
  'Não foi possível abrir o checkout. Tente novamente.';

export const CHOOSE_PLAN_INTERNAL_FREE_BILLING_NOTE =
  'Sem cartão · cobrança pelo Stripe não se aplica a este plano';

export const CHOOSE_PLAN_INTERNAL_FREE_HIGHLIGHT_LABEL = 'Plano gratuito';

export const CHOOSE_PLAN_SUBSCRIBE_INTERNAL_FREE_CTA = 'Começar grátis';

export const CHOOSE_PLAN_INTERNAL_FREE_ACTIVATING_LABEL = 'Ativando…';

export const CHOOSE_PLAN_TOAST_INTERNAL_FREE_OK = 'Plano gratuito ativado.';

export const CHOOSE_PLAN_TOAST_INTERNAL_FREE_FAILED =
  'Não foi possível ativar o plano gratuito. Tente novamente.';

/** Abas do período (afeta só o card premium). */
export const CHOOSE_PLAN_TAB_ARIA_LABEL = 'Período de cobrança do plano premium';

/** Badge no topo do card premium (à esquerda das abas). */
export const CHOOSE_PLAN_PREMIUM_BADGE_LABEL = 'Premium';

/** Exibido abaixo do título quando o período semestral está ativo. */
export const CHOOSE_PLAN_TAB_MOST_PURCHASED = 'Mais adquirido';

export const CHOOSE_PLAN_PREMIUM_PERIOD_UNAVAILABLE =
  'Não há plano premium cadastrado para este período no admin. Escolha outra opção ou fale com o suporte.';

/** Título de apoio se o plano gratuito não existir no Firestore. */
export const CHOOSE_PLAN_FREE_CARD_TITLE_FALLBACK = 'Plano Grátis';

/** Título do card premium (período fica nas abas e no preço). */
export const CHOOSE_PLAN_PREMIUM_CARD_TITLE = 'Plano Premium';

/** Título do bloco de benefícios (mesmo estilo nos dois cards). */
export const CHOOSE_PLAN_BENEFITS_CARD_TITLE = 'O que está incluído';

/** Fallback quando `free_limits.max_services` não veio do Firestore. */
export const CHOOSE_PLAN_FREE_DEFAULT_MAX_SERVICES_PER_MONTH = 15;

/** Linhas fixas do card grátis (a primeira linha vem de `free_limits`). */
export const CHOOSE_PLAN_FREE_BENEFITS_TAIL: readonly string[] = [
  '2 lembretes por serviço',
  'Suporte por email',
  'Preenchimento manual de serviços antigos',
];

export const CHOOSE_PLAN_PREMIUM_BENEFITS: readonly string[] = [
  'Registro ilimitado de serviços',
  '2 lembretes por serviço',
  'Suporte prioritário por WhatsApp',
  'Preenchimento de serviços antigos feito por nossa equipe',
  'Relatório mensal',
];
